import * as angular from 'angular';
import {StateProvider} from '@uirouter/angularjs';
import ListController from "./ListController";
import {CustomerController} from "./CustomerController";

class Routes {
    static $inject = ['$stateProvider'];

    constructor($stateProvider: StateProvider) {
        $stateProvider
            .state('company', {abstract:true})
            .state('company.list', {
                url: '/company',
                template: require('./List.html'),
                controller: ListController,
                controllerAs: 'vm',
                data: {title: 'Company List'}
            })
            .state('company.customer', {
                url: '/company/{companyGuid}/customer/{customerGuid}?add&name',
                params: {
                    customerGuid: {dynamic: true, value: null},
                    add: {dynamic: true, value: null},
                    name: {dynamic: true, value: null},
                },
                template: require('./Customer.html'),
                controller: CustomerController,
                controllerAs: 'vm',
                data: {title: 'Sub-Customer List'}
            })


    }
}

export default angular.module('app.company', [])
    .config(Routes)
    .name;
